import React, { memo, useMemo } from 'react';

import { useServiceItems } from '@hooks/api';
import { t } from 'ttag';

function Flagship() {
  const { serviceItems } = useServiceItems();

  const navigationItem = useMemo(
    () => serviceItems?.service.find(item => item.base_item_id === 1729),
    [serviceItems]
  );

  return (
    <a
      href={`/${navigationItem?.slug || ''}`}
      className="block p-1 text-black outline-none hover:underline focus:outline-none"
    >
      <span className="text-base">
        {navigationItem?.title || t`Find Store`}
      </span>
    </a>
  );
}

export default memo(Flagship);
